{
  "admission": "Nhập viện",
  "transfer": "Chuyển khoa",
  "visit": "Lượt khám",
  "type": "Loại lượt khám",
  "status": "Trạng thái",
  "location": "Vị trí",
  "attendingPhysician": "Bác sĩ điều trị",
  "admitDate": "Ngày nhập viện",
  "dischargeDate": "Ngày xuất viện",
  "chiefComplaint": "Lý do khám",
  "diagnosis": "Chẩn đoán",
  "class": {
    "label": "Phân loại",
    "values": {
      "emergency": "Cấp cứu",
      "inpatient": "Nội trú",
      "outpatient": "Ngoại trú",
      "observation": "Theo dõi",
      "ambulatory": "Khám trong ngày",
      "homeHealth": "Y tế tại nhà",
      "virtual": "Khám từ xa"
    }
  },
  "statusValues": {
    "label": "Trạng thái",
    "values": {
      "pending": "Chờ xử lý",
      "arrived": "Đã đến",
      "active": "Đang thực hiện",
      "completed": "Đã hoàn thành",
      "cancelled": "Đã hủy"
    }
  },
  "admissionSource": {
    "label": "Nguồn nhập viện",
    "none": "—",
    "values": {
      "emergency": "Khoa cấp cứu",
      "clinicReferral": "Chuyển từ phòng khám",
      "physicianReferral": "Bác sĩ giới thiệu",
      "transfer": "Chuyển từ cơ sở khác",
      "self": "Tự đến / Đi bộ vào",
      "courtLaw": "Tòa án / Cơ quan thi hành pháp luật"
    }
  },
  "admissionType": {
    "label": "Loại nhập viện",
    "none": "—",
    "values": {
      "elective": "Theo hẹn",
      "emergency": "Cấp cứu",
      "urgent": "Khẩn cấp",
      "newborn": "Trẻ sơ sinh",
      "trauma": "Chấn thương"
    }
  },
  "acuity": {
    "label": "Mức độ nặng",
    "none": "—",
    "values": {
      "1": "1 — Hồi sức",
      "2": "2 — Nguy kịch",
      "3": "3 — Khẩn cấp",
      "4": "4 — Bán khẩn cấp",
      "5": "5 — Không khẩn cấp"
    },
    "shortValues": {
      "1": "Hồi sức",
      "2": "Nguy kịch",
      "3": "Khẩn cấp",
      "4": "Bán khẩn cấp",
      "5": "Không khẩn cấp"
    },
    "esiBadge": "ESI {{level}} - {{label}}"
  },
  "form": {
    "title": "Lượt khám mới",
    "subtitle": "Bắt đầu một lượt khám / nhập viện mới cho bệnh nhân này.",
    "sections": {
      "visit": "Thông tin khám",
      "reasonForVisit": "Lý do khám",
      "admission": "Thông tin nhập viện"
    },
    "fields": {
      "facility": "Cơ sở y tế",
      "encounterClass": "Phân loại lượt khám",
      "encounterType": "Loại lượt khám",
      "department": "Khoa",
      "attendingProvider": "Bác sĩ điều trị",
      "acuity": "Mức độ nặng",
      "visitReason": "Lý do khám",
      "chiefComplaint": "Lý do chính",
      "admissionSource": "Nguồn nhập viện",
      "admissionType": "Loại nhập viện"
    },
    "placeholders": {
      "selectFacility": "Chọn cơ sở y tế",
      "none": "—",
      "encounterType": "VD: Khám sức khỏe định kỳ, Khám cấp cứu",
      "visitReason": "Nhãn ngắn, VD: Tái khám, Khám định kỳ",
      "chiefComplaint": "Lý do do chính bệnh nhân tự mô tả"
    },
    "providerFallback": "Bác sĩ #{{id}}",
    "submit": "Tạo lượt khám",
    "validation": {
      "facilityRequired": "Vui lòng chọn cơ sở y tế",
      "encounterClassRequired": "Vui lòng chọn phân loại lượt khám"
    },
    "createdSuccess": "Đã tạo lượt khám",
    "createError": "Không thể tạo lượt khám"
  },
  "detail": {
    "loading": "Đang tải lượt khám...",
    "notFound": "Không tìm thấy lượt khám",
    "loadError": "Tải lần khám thất bại",
    "retry": "Thử lại",
    "returnToDashboard": "Quay lại bảng điều khiển",
    "header": {
      "title": "Lượt khám {{number}}",
      "facilityLabel": "Cơ sở #{{id}}",
      "departmentLabel": "Khoa #{{id}}",
      "locationLabel": "Vị trí #{{id}}",
      "admittedLabel": "Nhập viện: {{datetime}}"
    },
    "actions": {
      "transfer": "Chuyển khoa",
      "discharge": "Xuất viện"
    },
    "tabs": {
      "overview": "Tổng quan",
      "orders": "Y lệnh",
      "results": "Kết quả",
      "medications": "Thuốc",
      "notes": "Ghi chép",
      "billing": "Thanh toán"
    },
    "overview": {
      "chiefComplaint": "Lý do chính",
      "visitReason": "Lý do khám",
      "attendingProvider": "Bác sĩ điều trị",
      "acuityLevel": "Mức độ nặng",
      "providerFallback": "Bác sĩ #{{id}}",
      "empty": "--"
    },
    "timeline": {
      "title": "Dòng thời gian sự kiện",
      "empty": "Chưa có sự kiện nào được ghi nhận",
      "admittedTitle": "Nhập viện",
      "admittedDescription": "{{class}} - {{chiefComplaint}}",
      "noChiefComplaint": "Không có lý do chính",
      "orderTitle": "Y lệnh: {{name}}",
      "orderDescription": "{{type}} - {{priority}} - {{status}}",
      "resultTitle": "Kết quả: {{type}}"
    },
    "orders": {
      "title": "Y lệnh",
      "newOrder": "+ Y lệnh mới",
      "empty": "Lượt khám này chưa có y lệnh",
      "metaLine": "{{number}} | {{type}} | Mức ưu tiên: {{priority}}"
    },
    "results": {
      "title": "Kết quả",
      "empty": "Lượt khám này chưa có kết quả",
      "criticalBadge": "NGUY KỊCH",
      "viewLink": "Xem",
      "metaLine": "{{number}} | {{status}}"
    },
    "medications": {
      "title": "Thuốc",
      "newMedication": "+ Thuốc mới",
      "empty": "Lượt khám này chưa có thuốc",
      "prnBadge": "PRN",
      "prnWithIndication": "PRN: {{indication}}"
    },
    "notes": {
      "comingSoon": "Mô-đun ghi chép lâm sàng sẽ sớm ra mắt",
      "goToClinicalNotes": "Đến ghi chép lâm sàng"
    },
    "billing": {
      "comingSoon": "Mô-đun thanh toán sẽ sớm ra mắt"
    }
  },
  "census": {
    "title": "Bảng giường / Danh sách nội trú",
    "subtitle": "Tình trạng giường và bệnh nhân nội trú theo thời gian thực",
    "refresh": "Làm mới",
    "facilityName": "Bệnh viện Đa khoa Singapore",
    "capacitySummary": "Đang dùng {{occupied}} / Tổng {{total}} giường",
    "occupancyLabel": "Tỷ lệ sử dụng {{percent}}%",
    "stats": {
      "totalCapacity": "Tổng số giường",
      "occupied": "Đã sử dụng",
      "available": "Còn trống",
      "pendingDischarge": "Chờ xuất viện"
    },
    "unitFilter": {
      "all": "Tất cả các khoa",
      "er": "ER",
      "icu": "ICU",
      "medsurg": "Nội / Ngoại",
      "obs": "Theo dõi",
      "peds": "Nhi khoa",
      "maternity": "Sản khoa"
    },
    "roleView": {
      "nurse": "Chế độ điều dưỡng",
      "physician": "Chế độ bác sĩ",
      "bedManager": "Chế độ quản lý giường"
    },
    "viewMode": {
      "grid": "Chế độ lưới",
      "table": "Chế độ bảng"
    },
    "loading": "Đang tải dữ liệu nội trú...",
    "columns": {
      "patient": "Bệnh nhân",
      "mrn": "MRN",
      "admitDate": "Ngày nhập viện",
      "status": "Trạng thái",
      "acuity": "Mức độ nặng",
      "isolation": "Cách ly",
      "fallRisk": "Nguy cơ té ngã",
      "codeStatus": "Phương án hồi sức",
      "chiefComplaint": "Lý do chính",
      "attending": "Điều trị",
      "los": "LOS",
      "locationBed": "Vị trí / Giường",
      "transferStatus": "Trạng thái chuyển khoa",
      "expectedDischarge": "Dự kiến xuất viện",
      "actions": "Thao tác"
    },
    "values": {
      "unknownPatient": "Không rõ",
      "none": "Không có",
      "notAvailable": "N/A",
      "pending": "Chờ xử lý",
      "empty": "--",
      "providerFallback": "Bác sĩ #{{id}}",
      "locationLabel": "Vị trí #{{id}}",
      "losDays": "{{days}} ngày"
    },
    "codeStatusTooltip": "Phương án hồi sức có sẵn trong hồ sơ bệnh nhân",
    "actionsMenu": {
      "label": "Thao tác",
      "viewChart": "Xem hồ sơ",
      "transfer": "Chuyển khoa",
      "assignAttending": "Chỉ định bác sĩ điều trị",
      "discharge": "Xuất viện"
    },
    "empty": "Không có lượt khám nội trú nào đang hoạt động",
    "department": {
      "filteredTo": "Chỉ hiển thị {{name}}",
      "idLabel": "Khoa {{id}}",
      "showAll": "Hiển thị tất cả các khoa"
    },
    "facility": {
      "label": "Cơ sở",
      "allFacilities": "Tất cả cơ sở",
      "idLabel": "Cơ sở {{id}}"
    }
  },
  "discharge": {
    "label": "Xuất viện",
    "title": "Quy trình Xuất viện",
    "encounterLabel": "Lượt khám {{number}}",
    "printButton": "In hồ sơ xuất viện",
    "loading": "Đang tải lượt khám...",
    "notFound": "Không tìm thấy lượt khám",
    "returnToDashboard": "Trở về Trang chính",
    "notActive": "Lượt khám này không đang hoạt động (trạng thái: {{status}})",
    "backToEncounter": "Trở về lượt khám",
    "progress": {
      "requiredMissingTooltip": "Thiếu trường bắt buộc",
      "tasksRemainingTooltip": "Còn nhiệm vụ chưa hoàn tất"
    },
    "steps": {
      "summary": "Tóm tắt Xuất viện",
      "medications": "Thuốc",
      "followup": "Tái khám",
      "instructions": "Hướng dẫn",
      "nursing": "Nhiệm vụ Điều dưỡng",
      "signoff": "Ký bởi Bác sĩ Điều trị",
      "review": "Rà soát & Xác nhận"
    },
    "summary": {
      "title": "Tóm tắt Xuất viện",
      "diagnosisLabel": "Chẩn đoán Xuất viện *",
      "diagnosisPlaceholder": "Nhập chẩn đoán xuất viện...",
      "diagnosisCodeLabel": "Mã Chẩn đoán Xuất viện (ICD-10)",
      "diagnosisCodePlaceholder": "Tìm mã ICD-10...",
      "proceduresLabel": "Các Thủ thuật đã thực hiện",
      "proceduresPlaceholder": "Liệt kê các thủ thuật đã thực hiện trong lượt khám này...",
      "conditionLabel": "Tình trạng khi Xuất viện *"
    },
    "condition": {
      "values": {
        "stable": "Ổn định",
        "improved": "Cải thiện",
        "unchanged": "Không thay đổi",
        "worsened": "Xấu đi",
        "critical": "Nguy kịch"
      }
    },
    "medications": {
      "title": "Thuốc Xuất viện",
      "instructions": "Xem xét từng thuốc và quyết định tiếp tục, ngừng hoặc điều chỉnh khi xuất viện.",
      "actions": {
        "continue": "Tiếp tục",
        "stop": "Ngừng",
        "modify": "Điều chỉnh"
      },
      "modifiedPlaceholder": "Nhập hướng dẫn đã điều chỉnh...",
      "empty": "Không có thuốc đang dùng cho lượt khám này"
    },
    "medAction": {
      "values": {
        "continue": "tiếp tục",
        "stop": "ngừng",
        "modify": "điều chỉnh"
      }
    },
    "followup": {
      "title": "Lịch Tái khám",
      "providerLabel": "Bác sĩ Tái khám",
      "providerPlaceholder": "Tên bác sĩ hoặc chuyên khoa...",
      "dateLabel": "Ngày Tái khám",
      "notesLabel": "Ghi chú thêm",
      "notesPlaceholder": "Ghi chú thêm về tái khám..."
    },
    "instructions": {
      "title": "Hướng dẫn cho Bệnh nhân",
      "generalLabel": "Hướng dẫn chung",
      "generalPlaceholder": "Hướng dẫn xuất viện chung cho bệnh nhân...",
      "dietaryLabel": "Hướng dẫn Dinh dưỡng",
      "dietaryPlaceholder": "Hạn chế hoặc khuyến nghị về ăn uống...",
      "activityLabel": "Hạn chế Vận động",
      "activityPlaceholder": "Hạn chế hoạt động thể chất...",
      "warningSignsLabel": "Dấu hiệu Cảnh báo cần Theo dõi",
      "warningSignsPlaceholder": "Triệu chứng cần tái khám hoặc tìm hỗ trợ y tế..."
    },
    "nursing": {
      "title": "Nhiệm vụ Điều dưỡng",
      "instructions": "Hoàn tất danh sách dưới đây trước khi xuất viện. Các mục này chỉ mang tính ghi nhận và không gọi API.",
      "tasks": {
        "removeIv": "Rút đường truyền IV",
        "discontinueMonitoring": "Ngừng thiết bị theo dõi",
        "patientEducation": "Đã hoàn tất giáo dục bệnh nhân",
        "medsReviewed": "Đã xem lại thuốc xuất viện với bệnh nhân",
        "belongingsReturned": "Đã trả lại đồ cá nhân",
        "transportArranged": "Đã sắp xếp phương tiện về"
      }
    },
    "signoff": {
      "title": "Ký bởi Bác sĩ Điều trị",
      "instructions": "Xem lại tóm tắt xuất viện bên dưới và ký xác nhận bởi bác sĩ điều trị.",
      "diagnosisHeading": "Chẩn đoán Xuất viện",
      "notProvided": "Chưa nhập",
      "medicationsHeading": "Thuốc Xuất viện",
      "noMedications": "Không có thuốc cần đối chiếu",
      "signedCompleted": "Bác sĩ điều trị đã ký xác nhận.",
      "signAsAttending": "Ký với tư cách Bác sĩ Điều trị",
      "requiresAttendingSignoff": "Cần chữ ký xác nhận của bác sĩ điều trị"
    },
    "review": {
      "title": "Rà soát & Xác nhận Xuất viện",
      "summaryHeading": "Tóm tắt Xuất viện",
      "fields": {
        "diagnosis": "Chẩn đoán:",
        "procedures": "Thủ thuật:",
        "condition": "Tình trạng:",
        "provider": "Bác sĩ:",
        "date": "Ngày:",
        "notes": "Ghi chú:",
        "general": "Chung:",
        "diet": "Dinh dưỡng:",
        "activity": "Vận động:",
        "warningSigns": "Dấu hiệu cảnh báo:"
      },
      "medicationsHeading": "Đối chiếu Thuốc",
      "noMedications": "Không có thuốc cần đối chiếu",
      "followupHeading": "Tái khám",
      "instructionsHeading": "Hướng dẫn cho Bệnh nhân",
      "noInstructions": "Chưa nhập hướng dẫn",
      "pendingOrdersWarning": "Có thể còn y lệnh chưa hoàn tất hoặc ghi chú chưa ký. Vui lòng kiểm tra trước khi hoàn tất xuất viện.",
      "diagnosisRequired": "Cần có chẩn đoán xuất viện trước khi hoàn tất xuất viện.",
      "empty": "--"
    },
    "nav": {
      "previous": "Trước",
      "next": "Tiếp",
      "complete": "Hoàn tất Xuất viện"
    },
    "toast": {
      "success": "Đã xuất viện bệnh nhân thành công",
      "error": "Không thể hoàn tất xuất viện"
    }
  },
  "components": {
    "transferDialog": {
      "title": "Chuyển ca khám",
      "description": "Chuyển bệnh nhân đến một vị trí khác trong cơ sở.",
      "targetLocationLabel": "Vị trí đích",
      "loadingLocations": "Đang tải các vị trí…",
      "selectLocation": "Chọn một vị trí",
      "emptyState": "Không còn vị trí hoạt động nào khác trong cơ sở này.",
      "reasonLabel": "Lý do",
      "reasonPlaceholder": "ví dụ: cần cách ly, giảm cấp ICU, giường theo dõi cao hơn",
      "actions": {
        "transfer": "Chuyển"
      },
      "toasts": {
        "success": "Đã chuyển ca khám",
        "error": "Không chuyển được ca khám"
      }
    },
    "assignAttendingDialog": {
      "title": "Chỉ định bác sĩ điều trị",
      "description": "Đặt bác sĩ điều trị chịu trách nhiệm cho lần khám này.",
      "providerLabel": "Bác sĩ điều trị",
      "loadingProviders": "Đang tải bác sĩ…",
      "selectProvider": "Chọn bác sĩ",
      "emptyState": "Cơ sở này không có bác sĩ đang hoạt động.",
      "actions": {
        "assign": "Chỉ định"
      },
      "toasts": {
        "success": "Đã chỉ định bác sĩ điều trị",
        "error": "Không thể chỉ định bác sĩ điều trị"
      }
    },
    "bedBoard": {
      "bedStatus": {
        "available": "Trống",
        "occupied": "Đang sử dụng",
        "reserved": "Đã đặt",
        "cleaning": "Đang dọn",
        "closed": "Đã đóng",
        "isolated": "Cách ly",
        "contaminated": "Bị nhiễm"
      },
      "acuityLegendLabel": "Mức độ ESI:",
      "empty": "Chưa cấu hình đơn vị nào",
      "summary": {
        "available_one": "{{count}} trống",
        "available_other": "{{count}} trống",
        "occupied_one": "{{count}} đang sử dụng",
        "occupied_other": "{{count}} đang sử dụng",
        "reserved_one": "{{count}} đã đặt",
        "reserved_other": "{{count}} đã đặt",
        "cleaning_one": "{{count}} đang dọn",
        "cleaning_other": "{{count}} đang dọn",
        "closed_one": "{{count}} đã đóng",
        "closed_other": "{{count}} đã đóng",
        "isolated_one": "{{count}} cách ly",
        "isolated_other": "{{count}} cách ly",
        "contaminated_one": "{{count}} bị nhiễm",
        "contaminated_other": "{{count}} bị nhiễm"
      }
    },
    "protocolPanel": {
      "title": "Đăng ký phác đồ",
      "enroll": "Đăng ký",
      "availableProtocols": "Phác đồ khả dụng",
      "loadingProtocols": "Đang tải phác đồ...",
      "noProtocols": "Không có phác đồ khả dụng",
      "stepBadge": "Bước {{current}}/{{total}}",
      "loadingEnrollments": "Đang tải đăng ký...",
      "noEnrollments": "Không có đăng ký phác đồ đang hoạt động",
      "completeStep": "Hoàn thành bước",
      "toasts": {
        "enrollSuccess": "Đã đăng ký phác đồ",
        "enrollError": "Đăng ký phác đồ thất bại",
        "advanceSuccess": "Bước đã hoàn thành",
        "advanceError": "Tiến bước thất bại"
      }
    }
  }
}
